import { create } from "../../../common/utils/zustand_state_manager";
import { IAuditorService } from "../../../features/auditoria/data/services/auditor_service";
import { AuditorService } from "../../../features/auditoria/data/services/auditor_service_impl";



//useAuditorService

type State = {
  auditorService: IAuditorService,
};

export const useAuditorService = create<State>((set, get) => ({
  auditorService: new AuditorService(),
}));